import React, { useEffect } from "react";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import Icon from "./Icon";
import Status from "../types/enum/Status";
import theme from "../styles/theme";
import Button from "./Button";
import { useNavigate } from "react-router-dom";
interface State {
  searchTerm: string;
}
type SearchBoxProps = {
  resetSearch: boolean | undefined;
  label: string;
  defaultKeyword?: string;
  onSearch: (x: string) => void;
  width?: number | undefined;
  keyword?: string;
  setKeyword?: (x: string) => void;
};
function SearchBox({
  resetSearch,
  label,
  defaultKeyword,
  onSearch,
  width,
  keyword,
  setKeyword
}: SearchBoxProps): JSX.Element {
  const isControlled = typeof keyword === "string";

  const [values, setValues] = React.useState<State>({
    searchTerm: defaultKeyword || "",
  });
  const handleChange =
    (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const next = event.target.value;
      if (!isControlled) {
        setValues((prev) => ({ ...prev, [prop]: next }));
      }
      setKeyword?.(next);
    };

  const navigate = useNavigate();
  useEffect(() => {
    if (isControlled) return;
    if (defaultKeyword) {
      setValues((prev) => ({ ...prev, searchTerm: defaultKeyword }));
    } else {
      setValues({ searchTerm: "" });
    }
  }, [defaultKeyword, resetSearch, isControlled]);

  if (
    window.location.pathname.includes("/modify/competency/") ||
    window.location.pathname.includes("/view/competency/detail/") ||
    window.location.pathname.includes("/version-competency/view/competency/detail")  
  ) {
    return (
      <div
        onClick={() => {
          window.location.pathname = "/modify/competency";
        }}
        className="reduce_opct_onhover"
        style={{
          color: "rgb(38, 51, 212)",
          alignItems: "center",
          display: "flex",
          gap: 10,
          cursor: "pointer",
        }}
      >
        {" "}
        <Icon name={"arrow_back"}></Icon> Back to all competencies
      </div>
    );
  }
  return (
    <>
      <FormControl
        size="small"
        sx={{
          mr: 1,
          width: width ? width : "200px",
          boxShadow: theme.shadow(2, Status.default),
        }}
        variant="outlined"
      >
        <InputLabel htmlFor="component-outlined">{label}</InputLabel>
        <OutlinedInput
          id="component-outlined"
          value={isControlled ? (keyword as string) : values.searchTerm}
          onChange={handleChange("searchTerm")}
          endAdornment={
            (isControlled ? keyword : values.searchTerm) ? (
              <InputAdornment
                onClick={() => {
                  setKeyword?.("");
                  localStorage.removeItem("currentPillar");
                  onSearch("");
                  setValues({
                    searchTerm: "",
                  });
                }}
                position="end"
                style={{ cursor: "pointer" }}
              >
                <Icon name={"close"}></Icon>
              </InputAdornment>
            ) : (
              <InputAdornment position="end">
                <Icon name={"search"}></Icon>
              </InputAdornment>
            )
          }
          label={label}
        />
      </FormControl>
      <Button
        disabled={(isControlled ? (keyword as string) : values.searchTerm) === ""}
        onClick={() => {
          onSearch(isControlled ? (keyword as string) : values.searchTerm);
        }}>
        Search
      </Button>
    </>
  );
}
export default SearchBox;